import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/classroom-interaction/group/group-avatar-no.png'


_pushScopeId("data-v-d915e082")
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "group-edit-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "group-action-title" }, "快速分组", -1)
const _hoisted_4 = { class: "group-item-header" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["groupIdx"]
const _hoisted_7 = ["groupIdx"]
const _hoisted_8 = ["studentId", "groupIdx"]
const _hoisted_9 = { class: "group-item" }
const _hoisted_10 = { class: "group-item-header" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "group-img",
    src: _imports_0
  })
], -1)
const _hoisted_12 = ["studentId"]
const _hoisted_13 = { class: "set-num-body" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "set-num-title" }, "将所有学生进行分组", -1)
const _hoisted_15 = { class: "set-num-input" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "set-num-input-text" }, "分为", -1)
const _hoisted_17 = { class: "random-select" }
const _hoisted_18 = { class: "random-select-num" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "set-num-input-text" }, "组", -1)
_popScopeId()

import BaseModal from "../base/BaseModal.vue";
import {
  ref,
  inject,
  computed,
  onMounted,
  watch,
  onBeforeUnmount,
  reactive,
} from "vue";
import {
  createGroupPlan,
  editGroupPlan,
  setGroupEvaluateNormScoreByStudentSum,
} from "@/services/classroomInteraction";
import { ElMessage } from "element-plus";
import _ from "lodash";


export default _defineComponent({
  props: {
  isCreate: {
    type: Boolean,
    default: () => false,
  },
  groupPlanId: {
    type: Number,
    default: () => 0,
  },
  groupDetail: {
    type: Array,
    default: () => null,
  },
},
  setup(__props) {

const props = __props
const visible = inject("createGroupVisible", false);
const schoolClassId = inject("schoolClassId", false);
const getClassData = inject("getClassData", (v: number) => null, false);
const handleUpdateStudentAndGroupData = inject(
  "handleUpdateStudentAndGroupData",
  () => null,
  false
);
const studentList = inject<any>("studentList");
const lessonId = inject("lessonId");
const CIBodyRef: any = inject("CIBodyRef");

const setGroupNumVisible = ref(props.isCreate);
const setGroupVisible = ref(!props.isCreate);
const isCreate = computed(() => props.isCreate);
const groupDetail = computed(() => props.groupDetail);
const groupPlanId = computed(() => props.groupPlanId);
let timer: any;

// 移动端拖动跟随元素
const draggingElement: any = reactive({
  show: false,
  style: {},
  innerHTML: "",
});
const dragState: any = reactive({
  active: false,
  x: 0,
});
const clearDraggingImg = () => {
  draggingElement.show = false;
  draggingElement.style = {};
  draggingElement.innerHTML = "";
};

const handleCancel = () => {
  visible.value = false;
};
const groupNum = ref(
  studentList.value.length >= 5 ? 4 : studentList.value.length - 1
);
if (studentList.value.length < 4) {
  groupNum.value = 2;
}
// 当前分组
const currentGroupList = ref([]);
// 未分组
const noGroupList = ref<any>([]);

const groupsParams = computed(() =>
  currentGroupList.value.map((i) => {
    return {
      ...(i.id && { group_id: i.id }),
      students: i.students.map((j) => ({ student_id: j.id })),
    };
  })
);

const genInitGroupData = () => {
  noGroupList.value = [];
  currentGroupList.value = [];
  for (let i = 0; i < groupNum.value; i++) {
    currentGroupList.value.push({ students: [] });
  }
  const shuffleStudentList = _.shuffle(studentList.value);
  shuffleStudentList.forEach((student: any, index: number) => {
    currentGroupList.value[index % groupNum.value].students.push(student);
  });
};

const handleSubmit = () => {
  genInitGroupData();
  setGroupVisible.value = true;
  setGroupNumVisible.value = false;
};

const handleSubmitGroup = async () => {
  try {
    let newGroupPlanId = 0;
    if (isCreate.value) {
      const {
        data: { group_plan_id },
      } = await createGroupPlan({
        school_class_id: schoolClassId.value,
        groups: groupsParams.value,
      });
      newGroupPlanId = group_plan_id;
      ElMessage.success({
        message: "创建成功",
      });
    } else {
      await editGroupPlan({
        group_plan_id: groupPlanId.value,
        groups: groupsParams.value,
      });
      if (groupDetail?.value?.score_type === 2) {
        const params = {
          lesson_id: lessonId.value,
          group_plan_id: groupPlanId.value,
        };
        await setGroupEvaluateNormScoreByStudentSum(params);
      }

      ElMessage.success({
        message: "修改成功",
      });
    }

    getClassData?.(newGroupPlanId);
    handleUpdateStudentAndGroupData?.();

    setTimeout(() => {
      handleCancel();
    }, 2000);
  } catch (e) {
    ElMessage.error({
      message: "请求失败",
    });
    console.error(e);
  }
};
const sceneRef = ref();
const activeItem = ref();

const handleDragStart = (element: any) => {
  dragState.active = true;
  activeItem.value = {
    studentId: parseInt(element.getAttribute("studentId")),
    groupIdx: parseInt(element.getAttribute("groupIdx")),
  };
};

const handleDrop = (element: any) => {
  dragState.active = false;
  const toGroupIdx = parseInt(element.getAttribute("groupIdx") || -2);
  const fromGroupIdx = activeItem.value.groupIdx;
  if (toGroupIdx === -2 || fromGroupIdx === -2) {
    return;
  }
  if (toGroupIdx >= -1 && fromGroupIdx !== toGroupIdx) {
    // 交换
    let current;
    if (fromGroupIdx === -1) {
      // 未分组
      current = noGroupList.value.find(
        (i) => i.id === activeItem.value.studentId
      );
      noGroupList.value = noGroupList.value.filter(
        (i) => i.id !== activeItem.value.studentId
      );
    } else {
      current = currentGroupList.value[fromGroupIdx].students.find(
        (i) => i.id === activeItem.value.studentId
      );
      currentGroupList.value[fromGroupIdx].students = currentGroupList.value[
        fromGroupIdx
      ].students.filter((i) => i.id !== activeItem.value.studentId);
    }

    if (toGroupIdx === -1) {
      // 未分组
      noGroupList.value.push(current);
    } else {
      currentGroupList.value[toGroupIdx].students.push(current);
    }
  }
  activeItem.value = {};
};

const onDragStart = (e: any) => {
  handleDragStart(e.target);
};
const onDrop = (e: any) => {
  const element = e.target;
  handleDrop(element);
};
const onDragover = (event: any) => {
  dragState.x = event.clientX;
  draggingElement.x = event.clientX;
  event.preventDefault();
};
const onTouchStart = (e: any) => {
  const element: any = e.target;
  if (e.cancelable) {
    e.preventDefault();
  }
  draggingElement.innerHTML = element.innerHTML;
  draggingElement.height = element.offsetHeight;
  draggingElement.width = element.offsetWidth;

  handleDragStart(element);
  const sourceTouch = e.changedTouches[0];
  draggingElement.style = {
    height: `${draggingElement.height}px`,
    width: `${draggingElement.width}px`,
    top: `${sourceTouch.clientY}px`,
    left: `${sourceTouch.clientX}px`,
  };
  draggingElement.show = true;
};
const onTouchEnd = (e: any) => {
  const sourceEl = e.changedTouches[0];
  if (!draggingElement.show) {
    return;
  }
  clearDraggingImg();
  setTimeout(() => {
    const targetEl = document.elementFromPoint(
      sourceEl.clientX,
      sourceEl.clientY
    );
    handleDrop(targetEl);
  });
};

const startListenDraggingMove = () => {
  const screenWidth = document.body.clientWidth;
  if (timer) {
    return;
  }
  timer = setInterval(() => {
    if (!dragState.active && !draggingElement.show) {
      return;
    }
    const scrollLeft = sceneRef.value.scrollLeft;
    const maxDistance = sceneRef.value.scrollWidth - sceneRef.value.clientWidth;
    const x = draggingElement.x;
    const delta = 10;
    const activeDistance = screenWidth / 3;
    if (screenWidth - x < activeDistance) {
      sceneRef.value.scrollTo(scrollLeft + delta, 0);
    }
    if (x < activeDistance) {
      sceneRef.value.scrollTo(scrollLeft - delta, 0);
    }
  }, 20);
};

const stopListenDraggingMove = () => {
  clearInterval(timer);
  timer = 0;
};

const onTouchMove = _.throttle((e: any) => {
  const sourceTouch = e.changedTouches[0];
  if (!draggingElement.show) {
    return;
  }
  if (e.cancelable) {
    e.preventDefault();
  }
  const style = {
    top: `${sourceTouch.clientY}px`,
    left: `${sourceTouch.clientX}px`,
  };
  draggingElement.x = sourceTouch.clientX;
  draggingElement.y = sourceTouch.clientY;
  draggingElement.style = style;
}, 20);

const onWheel = (event) => {
  // if (event.target.className === "group-action-body") {
  if (event.target.className !== "member-name-text") {
    event.preventDefault();
    const scrollLeft = sceneRef.value.scrollLeft;
    sceneRef.value.scrollTo(scrollLeft + event.deltaX, 0);
  }
};

const mouseSlipState = reactive({
  active: true,
  delta: 0,
  scrollLeft: 0,
});

const onMousedown = (event) => {
  if (event.target.className === "group-action-body") {
    mouseSlipState.active = true;
    mouseSlipState.delta = event.clientX; // 获取到点击的x下标
    mouseSlipState.scrollLeft = sceneRef.value.scrollLeft; // 获取当前元素滚动条的偏移量
  }
};

const onMousemove = (event) => {
  if (mouseSlipState.active) {
    // 判断是否是鼠标按下滚动元素区域
    // 获取移动的x轴
    const moveX = event.clientX;
    // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
    const scrollX = moveX - mouseSlipState.delta;
    // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
    sceneRef.value.scrollTo(mouseSlipState.scrollLeft - scrollX, 0);
  }
};

const onMouseleaveAndUp = (event) => {
  mouseSlipState.active = false;
};

const onDragend = (e) => {
  dragState.active = false;
  draggingElement.show = false;
  stopListenDraggingMove();
};

const startListenMouseSlip = () => {
  sceneRef.value.addEventListener("mousedown", onMousedown);
  sceneRef.value.addEventListener("mousemove", onMousemove);
  sceneRef.value.addEventListener("mouseup", onMouseleaveAndUp);
  // 鼠标离开元素停止拖动
  sceneRef.value.addEventListener("mouseleave", onMouseleaveAndUp);
  document.body.addEventListener("dragend", onDragend);
  document.body.addEventListener("touchend", onDragend);
};

const cancelListenMouseSlip = () => {
  if (sceneRef.value) {
    sceneRef.value.removeEventListener("mousedown", onMousedown);
    sceneRef.value.removeEventListener("mousemove", onMousemove);
    sceneRef.value.removeEventListener("mouseup", onMouseleaveAndUp);
    sceneRef.value.removeEventListener("mouseleave", onMouseleaveAndUp);
    document.body.removeEventListener("dragend", onDragend);
    document.body.removeEventListener("touchend", onDragend);
  }
};

const handleInit = () => {
  if (!sceneRef.value) {
    return;
  }
  sceneRef.value.addEventListener("dragover", onDragover);
  // 禁止页面滑动
  document.body.style.overflow = "hidden";
  sceneRef.value.addEventListener("touchmove", onTouchMove);
  // sceneRef.value.addEventListener("wheel", onWheel);
};
const handleUnmounted = () => {
  if (!sceneRef.value) {
    return;
  }
  sceneRef.value.removeEventListener("dragover", onDragover);
  sceneRef.value.removeEventListener("touchmove", onTouchMove);
  // sceneRef.value.removeEventListener("wheel", onWheel);
};
const handleSelectModalClose = () => {
  if (!setGroupVisible.value) {
    handleCancel();
  }
};
const handleReduce = () => {
  const min = 2;
  if (groupNum.value > min) {
    groupNum.value--;
  } else {
    groupNum.value = min;
  }
};
const handleAdd = () => {
  const max = studentList.value.length - 1;
  if (groupNum.value < max) {
    groupNum.value++;
  } else {
    groupNum.value = max;
  }
};
// 将节点挂载到body
const setBodyRef = () => CIBodyRef.value;

watch(
  () => visible.value,
  (v) => {
    if (v) {
      currentGroupList.value = groupDetail.value?.groups || [];
      let hasGroupStudentList: any[] = [];
      currentGroupList.value.forEach((i) => {
        hasGroupStudentList = [...hasGroupStudentList, ...i.students];
      });
      noGroupList.value = studentList.value.filter(
        (i) => !hasGroupStudentList.map((j) => j.id).includes(i.id)
      );
    }
  },
  { immediate: true }
);
watch(
  () => sceneRef.value,
  (v) => {
    if (v) {
      handleInit();
      startListenMouseSlip();
    } else {
      cancelListenMouseSlip();
    }
  },
  { immediate: true }
);
watch(
  () => draggingElement.show,
  (v) => {
    if (v) {
      startListenDraggingMove();
    } else {
      stopListenDraggingMove();
    }
  },
  { immediate: true }
);
watch(
  () => dragState.active,
  (v) => {
    if (v) {
      startListenDraggingMove();
    } else {
      stopListenDraggingMove();
    }
  },
  { immediate: true }
);
onMounted(() => {
  //
});
onBeforeUnmount(() => {
  handleUnmounted();
  stopListenDraggingMove();
  cancelListenMouseSlip();
});

return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "create-group-container",
        style: _normalizeStyle({ backgroundColor: setGroupVisible.value && 'white' })
      }, [
        (_unref(draggingElement).show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "dragging-el",
              innerHTML: _unref(draggingElement).innerHTML,
              style: _normalizeStyle(_unref(draggingElement).style)
            }, null, 12, _hoisted_1))
          : _createCommentVNode("", true),
        (setGroupVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h3", {
                class: "close",
                onClick: handleCancel
              }, "X"),
              _hoisted_3,
              _createElementVNode("div", {
                class: "group-action-container",
                ref: sceneRef
              }, [
                _createElementVNode("div", {
                  class: "group-action-body",
                  style: _normalizeStyle({
            width:
              currentGroupList.value.length < 5
                ? '100%'
                : `${20 * (currentGroupList.value.length - 4) + 100}%`,
          })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentGroupList.value, (group, gIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: gIndex,
                      class: "group-item"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            class: "group-img",
                            src: 
                    require(`@/assets/images/classroom-interaction/group/group-avatar-${
                      (gIndex % 8) + 1
                    }.png`)
                  
                          }, null, 8, _hoisted_5)
                        ]),
                        _createElementVNode("div", null, "第" + _toDisplayString(gIndex + 1) + "组 " + _toDisplayString(group.students.length) + "人", 1)
                      ]),
                      _createElementVNode("div", {
                        class: "group-item-member",
                        groupIdx: gIndex,
                        onDrop: onDrop,
                        onTouchend: onTouchEnd
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.students, (student) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "member-name",
                            key: student.id,
                            groupIdx: gIndex
                          }, [
                            _createElementVNode("text", {
                              class: "member-name-text",
                              draggable: true,
                              onDragstart: onDragStart,
                              onTouchstart: onTouchStart,
                              studentId: student.id,
                              groupIdx: gIndex
                            }, _toDisplayString(student.name), 41, _hoisted_8)
                          ], 8, _hoisted_7))
                        }), 128))
                      ], 40, _hoisted_6)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", null, "未分组 " + _toDisplayString(noGroupList.value.length) + "人", 1)
                    ]),
                    _createElementVNode("div", {
                      class: "group-item-member",
                      groupIdx: -1,
                      onDrop: onDrop,
                      onTouchend: onTouchEnd
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noGroupList.value, (student) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "member-name",
                          key: student.id,
                          groupIdx: -1
                        }, [
                          _createElementVNode("text", {
                            class: "member-name-text",
                            draggable: true,
                            onDragstart: onDragStart,
                            onTouchstart: onTouchStart,
                            studentId: student.id,
                            groupIdx: -1
                          }, _toDisplayString(student.name), 41, _hoisted_12)
                        ]))
                      }), 128))
                    ], 32)
                  ])
                ], 4)
              ], 512),
              _createElementVNode("div", { class: "group-action-footer" }, [
                _createElementVNode("div", {
                  class: "base-btn confirm",
                  onClick: handleSubmitGroup
                }, "确定")
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(BaseModal, {
          visible: setGroupNumVisible.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (setGroupNumVisible.value = $event)),
          showHeaderBackground: false,
          onOnClose: handleSelectModalClose,
          getContainer: setBodyRef
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: "random-select-reduce",
                    onClick: handleReduce
                  }, "-"),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(groupNum.value), 1),
                  _createElementVNode("div", {
                    class: "random-select-add",
                    onClick: handleAdd
                  }, "+")
                ]),
                _hoisted_19
              ])
            ]),
            _createElementVNode("div", { class: "set-num-footer" }, [
              _createElementVNode("div", {
                class: "base-btn confirm",
                onClick: handleSubmit
              }, "确定")
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ], 4))
    : _createCommentVNode("", true)
}
}

})